/* ==========================================================================
   Ajout automatique du produit offert au panier.

   Se déclenche uniquement après un ajout réussi depuis une fiche produit
   (evenement 'cart-update', source 'product-form'). Le mapping pointure ->
   variante cadeau est calculé cote serveur par snippets/gift-auto-add.liquid
   et lu ici dans un bloc JSON. Ce fichier ne decide rien, il execute.

   Principe : le cadeau est un bonus, jamais un blocage. Toute erreur reseau,
   rupture de stock ou config absente est avalee en silence -- l'ajout du
   produit principal reste valide dans tous les cas.
   ========================================================================== */
(function () {
  'use strict';

  var configElement = document.getElementById('GiftAutoAddConfig');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (e) {
    return;
  }
  if (!config || !config.map) return;

  var giftVariants = (config.giftVariants || []).map(Number);
  var busy = false;

  function routeTo(key, fallback) {
    return (window.routes && window.routes[key]) || fallback;
  }

   // Lit l'etat du panier directement dans le tiroir, qui reflete le panier
  // d'avant cet ajout. Evite un aller-retour /cart.js inutile.
  function giftAlreadyInCart() {
    return giftVariants.some(function (variantId) {
      return (
        document.querySelector(
          'cart-drawer [data-quantity-variant-id="' + variantId + '"], ' +
          'cart-drawer [data-variant-id="' + variantId + '"]'
        ) !== null
      );
    });
  }

  function addGift(giftVariantId) {
    if (giftAlreadyInCart()) return Promise.resolve();

    var drawer = document.querySelector('cart-drawer');
    var sectionIds = drawer
      ? drawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      : [];

    return fetch(routeTo('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: giftVariantId, quantity: 1, properties: { _cadeau: 'offert' } }],
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (result) {
        if (!result || result.status) return;
        if (drawer && result.sections) drawer.renderContents(result);
      })
      .catch(function () {});
  }

  function onCartUpdate(event) {
    if (!event || event.source !== 'product-form') return;
    if (busy) return;

    var giftVariantId = config.map[String(event.productVariantId)];
    if (!giftVariantId) return;

    busy = true;
    return addGift(giftVariantId).then(
      function () {
        busy = false;
      },
      function () {
        busy = false;
      }
    );
  }

  var eventName = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';
  if (typeof subscribe === 'function') subscribe(eventName, onCartUpdate);
})();